/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { mixins } from '@blend/consumer-components';

import { AgentCard, Assignee } from '../AgentCard/AgentCard';
// import { ActionButton } from '../../../borrowerApp/components/common';

const styles = StyleSheet.create({
  buttonWrapper: mixins.marginVertical(30),
});

export namespace VerificationFailure {
  export interface Props extends React.HTMLAttributes<HTMLDivElement> {
    assignee?: Assignee;
  }
}

export const VerificationFailure: React.FC<VerificationFailure.Props> = ({ assignee }) => {
  return (
    <>
      {assignee && <AgentCard assignee={assignee} />}
      <div className={css(styles.buttonWrapper)} data-it="Return-Button">
        {/* TODO: (RON-300) on click to redirect back to loan hub */}
        {/* <ActionButton onClick={() => {}}>Return to loan hub</ActionButton>*/}
      </div>
    </>
  );
};
